import { cn } from "@/lib/utils";

interface AIAssistantToolbarProps {
  isAnalyzing: boolean;
  onFileUpload: (file: File) => Promise<void>;
}

export function AIAssistantToolbar({
  isAnalyzing,
  onFileUpload,
}: AIAssistantToolbarProps) {
  return (
    <div className="relative flex items-center justify-end gap-4">
      <input
        id="file-upload"
        type="file"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            onFileUpload(file);
          }
        }}
        accept=".pdf,.doc,.docx,.txt"
        aria-label="Velg dokument for opplasting"
      />
    </div>
  );
}